import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi } from '../../api/crm';

export function CustomerAnalyticsPage() {
  const [analytics, setAnalytics] = useState<{ total_customers: number; avg_ltv: number; vip_customers: number } | null>(null);

  useEffect(() => {
    void crmApi.analytics().then(setAnalytics);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/customers" className="text-sm text-slate-600 hover:underline">← CRM hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Customer analytics</h1>
      {analytics && (
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Total customers</p><p className="text-xl font-semibold">{analytics.total_customers}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Avg LTV</p><p className="text-xl font-semibold">₹{analytics.avg_ltv.toFixed(0)}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">VIP customers</p><p className="text-xl font-semibold">{analytics.vip_customers}</p></div>
        </div>
      )}
    </div>
  );
}
